// extracted by mini-css-extract-plugin
export default {"blockchainDetailButton":"StellarBlockchain_blockchainDetailButton__U6jnP"};